import {ERROR_TYPES, ERROR_CODES} from '@/constants';

const createError = (type, i18nKey, error) => ({
  type,
  i18nKey,
  original: error,
});

const createGenericError = (error) => createError(ERROR_TYPES.GENERIC, 'errors.generic.error', error);

const extractErrorCode = (error) => {
  const errorArray = error.data?.error?.[0];
  if (!Array.isArray(errorArray)) return undefined;

  const errorItem = errorArray.find((item) => item?.error);
  return errorItem?.error?.code;
};

export const mapCartError = (error) => {
  if (!error?.status || error.status !== 400) {
    return createGenericError(error);
  }

  const errorCode = extractErrorCode(error);

  if (errorCode === ERROR_CODES.PURCHASE_LIMIT) {
    return createError(
      ERROR_TYPES.PURCHASE_LIMIT,
      'errors.cart.purchase_limit_reached',
      error,
    );
  }

  return createGenericError(error);
};
